<!--
 * @Author: Merlin
 * @Date: 2023-12-19 10:36:47
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 17:10:19
 * @Description: 
-->

<template>
    <NuxtLayout name="game-coat"
        :topHeight="'500px'"
    >
        <template #bgImg>
            <img :src="emptyPic" 
                :style="{content: bgImg}"
            />
        </template>
        <template #panel-left>
            <div class="two-btn-coat" >
                <!-- ↓ 游戏期间应禁用 two-btn-coat 内部的下拉菜单，按钮等 -->
                <DropDown 
                    v-if="aRiskOptionArr.length > 0" 
                    v-model="sRisk"
                    :options="aRiskOptionArr" 
                    class="h-[48px] w-full risk-picker"
                    :disabled="isPanelDisable"
                    :prevLabel="$t('keno.RiskLevel')"
                    showOptionIcon
                    @update:modelValue="(newValue) => oFn.handleSelectUpdate(newValue)"
                >
                    <template #prevIcon>
                        <p style="min-width: 24px;" v-html="prevIcon"></p>
                    </template>
                </DropDown>
                <ButtonThe3DButton
                    color="blue"
                    size="lg"
                    v-click-and-rest
                    :disabled="isPanelDisable"
                    :dismark="isPanelDisable"
                    @click="oFn.autoPick"
                >
                    {{$t('keno.AutoPick')}}
                </ButtonThe3DButton>
                <button
                    class="gray-btn" 
                    @click="oFn.cleanTable"
                    :disabled="isPanelDisable || !aPicked.length"
                    :dismark="isPanelDisable || !aPicked.length"
                >
                    {{ $t('keno.ClearTable') }}
                </button>
            </div>
            <!-- 分界 -->
            <CasinoBetOptionSection
                class="mt-2"
                v-model:bet-amount-modal-value="oForm.amount"
                v-model:is-submiting="isPanelDisable"
                :isAuto="isAutoMode"
                @change-mode="toChangeMode"
            >
                <template #bet-button>
                    <ButtonThe2RowsButton
                        narrow
                        class="h-full"
                        full-width
                        size="lg"
                        @click="oFn.clickBetBtn"
                        :disabled="isBetBtnDisable"
                        :dismark="isBetBtnDisable"
                        v-click-and-rest
                    >
                        {{ sBetBtnName }}
                        <template #secondRow v-if="isAutoMode">
                            <span class="inline-block mt-1">
                                {{ autoOption.sRoundsRest }}
                            </span>
                        </template>
                    </ButtonThe2RowsButton>
                </template>
                <!-- 点击触发预警target -->
                <template #button-mask v-if="!aPicked?.length">
                    <div class="button-mask" @click="oFn.handleClickMask"></div>
                </template>
            </CasinoBetOptionSection>
        </template>
        <!--
            ================ 左右大分界 ================================================================
        -->
        <template #playing-area-right>
            <div class="keno-main"
                :class="{
                    'no-animate': oGlobalStore.client && !oSetting.animation,
                }"
            >
                <div class="blue-bg"></div>
                <!-- ↑背景图 -->
                <div class="keno-right-top">
                    <div class="board" :class="showWarning ? 'arrow-box' : ''">
                        <button v-for="(curNo) of 40" :key="curNo" 
                            class="number-btn"
                            :class="oFn.getBtnClassName(curNo)"
                            @click="oFn.clickNumber(curNo)"
                            :disabled="(aPicked.length >= 10 && !aPicked.includes(curNo)) || isLocking || oForm.isSubmiting"
                        >
                            <span>{{curNo}}</span>
                        </button>
                        <!-- ↓ -->
                        <i v-for="(sCur, idx) of aStar" :key="idx"
                            class="board__decor-point"
                            :class="sCur"
                        ></i>
                        <ClientOnly>
                            <video v-for="(oCur, idx) of aSideVideo"
                                :key="idx"
                                class="side-video"
                                :class="oCur.className"
                                :ref="(theDom) => oCur.dom=theDom"
                                src="./img/side-movie.webm" 
                                loop
                                :autoplay="oSetting.animation"
                            />
                        </ClientOnly>
                        <!-- ↓游戏结果弹出窗口 -->
                        <article class="keno-result"
                            v-show="isGameDone"
                        >
                            <div class="keno-result__wrap">
                                <div class="keno-result__block"
                                    v-if="oGameResult.winAmount > 0"
                                >
                                    <img class="keno-result__decor-wave" src="./img/waves.webp"  >
                                    <img class="keno-result__decor-stone keno-result__decor-stone--left" src="./img/stone-left.webp"  >
                                    <img class="keno-result__decor-stone keno-result__decor-stone--right" src="./img/stone-right.webp"  >
                                    <img class="keno-result__decor-bubble" src="./img/bubbles.webp"  >
                                    <img class="keno-result__decor-bubble keno-result__decor-bubble--help" src="./img/bubbles.webp"  >
                                    <p  class="keno-result__multi">
                                        {{ oGameResult.multi }}x
                                    </p>
                                    <div class="keno-result__value">
                                        <span class="currency">
                                            <CurrentCoin class="currency__icon" size="28px" ></CurrentCoin>
                                            <span class='money-value'>
                                                <span  class="font-digits">
                                                    {{getFixed(oGameResult.winAmount)}}
                                                </span>
                                            </span>
                                        </span>
                                        <p class="keno-result__currency">
                                            {{ oUserStore.oNowCurrency.currencyName }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
                <!--
                    ================ ↓ 下方信息条 ================================================================
                -->
                <div class="keno-right-bottom ">
                    <span class="light light-left"/>
                    <span class="light light-right"/>
                    <ul class="win-list" v-if="aWinList.length">
                        <li v-for="(cur, idx) of aWinList" :key="idx"
                            class="list-item"
                            :class="oFn.getBottomBarClassName(idx)"
                        >
                            <i class="ball-number" >
                                {{ idx }}
                                <img class="active" src="./img/coef-ball-active.webp"/>
                                <img class="normal" src="./img/coef-ball.png"/>
                            </i>
                            <em class="coeficient-item__x" >
                                {{cur}}x
                            </em>
                        </li>
                    </ul>
                    <p v-else class="coeficient-item__text">
                        {{ $t('keno.PickFrom1') }}
                    </p>
                </div>
            </div>
        </template>
    </NuxtLayout>
    <!-- ↓ 自动下注的输入面板（弹窗） -->
    <CasinoAutoSection
        :is-fast="false"
        :is-submiting="oForm.isSubmiting"
        :is-auto="isAutoMode"
        v-model:amount="oForm.amount"
        :ref="el => oAutoDialog=el"
        :gameName="'kenoGame'" 
    />
</template>

<script setup lang="ts">
// import bgImg from './img/keno-bg.webp';
import kenoBGM from '@/assets/mp3/keno/music_loop.mp3';
import clickSound from '@/assets/mp3/keno/click.mp3';
import looseSound from '@/assets/mp3/keno/loose.mp3';
import winSound from '@/assets/mp3/keno/achievement.mp3';
import ballSound from '@/assets/mp3/keno/ball.mp3';
import resultSound from '@/assets/mp3/keno/result.mp3';
// ↑ 静态资源：图、音乐 -----------------------------------------------
import type { FormObject } from '@/common/js/bettingToolkit/index';
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import {aRiskOptions} from './js/keno.js';
import { useGameHistoryStore } from '@/stores/cansino/gameHistory';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useUserStore } from '~/stores/user';
import {useAutoBetToolKit} from '@/common/js/bettingToolkit/auto';
import useSettingsStore from '@/stores/settings/index';
import useGlobalStore from '@/stores/global';
import { useI18n } from "vue-i18n";
import {betableCheck} from '@/common/js/betHelper';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';

// ↑ 导入 ---------------------------------------
import {useKenoSocket} from '@/socket/game/keno';
import { showTips4BadAmountIfNeeded } from '@/common/js/betHelper';

const {EMIT_KENO_BET} = useKenoSocket();
const {t: $t} = useI18n();
const oSettingsStore = useSettingsStore();
const oGameHistoryStore = useGameHistoryStore();
const oJoinStateStore = useJoinStateStore();
const oUserStore = useUserStore();
const oGlobalStore = useGlobalStore();
const autoOption = useAutoOptionStore();

interface GameResult {
    roll_number: Array<number>;
    selected: Array<number>;
    hash: string;
    amount: number;
    balanceBefore: number;
    confirmed: boolean;
    currency: string;
    diff: number;
    multi: number;
    randomSeed: string;
    risk: string;
    timestamp: string;
    user: object;
    winAmount: number;
    _id: number;
};

// ↓ Mini 版背景 
const bgImg = `linear-gradient(180deg, #140737, #140737 65.38%, rgba(20, 7, 55, 0) 84.65%)`;
const oMusic = import.meta.client && new MusicControler({
    bg: {
        src: kenoBGM,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    click:{ src: clickSound },
    win:{ src: winSound },
    lose:{ src: looseSound },
    ball: { src: ballSound },
    result: { src: resultSound },
} as any);

const aStar = [
    'board__decor-point--left-top',
    'board__decor-point--right-top',
    'board__decor-point--left-bottom',
    'board__decor-point--right-bottom',
];
const aSideVideo = ref([{
    dom: null,
    className: 'left',
},{
    dom: null,
    className: 'right',
},]);

const aRiskOptionArr = computed(() => {
    const arr = aRiskOptions.map(cur => {
        return {
            ...cur,
            name: $t(cur.i18n),
        };
    });
    return arr;
});

const oAutoDialog = ref(null);
const oDefault = aRiskOptionArr.value[1];
const isAutoMode = ref(false);
const isLocking = ref(false); // 自动选择执行中……
const isGameDone = ref(false); // 值为 true 显示结果
const sRisk = ref(oDefault.value);
const prevIcon = ref(oDefault.optionIcon);
const aPicked = reactive([]); // 用户选择
const aRollNumber = reactive([]); // 开奖结果
const oGameResult = reactive({} as GameResult);
const oForm = ref<FormObject>({
    amount: 0,
    isSubmiting: false, // 状态为 false 则停止自动下注
});
const showWarning = ref(false) // 是否显示预警动画
let isUnmounted = false;

// --------------------------------------------------------
//      ↑ 声明变量 ↓ computed
// --------------------------------------------------------


const coeficients = computed(()=>{
    const oResult = {
        low: oJoinStateStore.config.low,
        medium: oJoinStateStore.config.medium,
        hight: oJoinStateStore.config.hight,
    }
    return oResult;
});

const aNumbersHits = computed(()=>{
    const arr = aPicked.filter(curNo=>{
        return aRollNumber.includes(curNo);
    });
    return arr;
});
// ↓ 动画与加速设定
const oSetting = computed(()=>{
    return oSettingsStore.inhouseGames.keno;
});

// ↓ 倍数
const aWinList = computed(()=>{
    if (!aPicked.length) return [];
    const arr = coeficients.value[sRisk.value] || [];
    const aResult = arr[aPicked.length] || [];
    // 调取当前最大赔付额提示
    const kenoMaxWin = Number(oForm.value.amount.beFixed(2)) * Number(aResult?.[aResult?.length-1])
    showTips4BadAmountIfNeeded(kenoMaxWin)
    return aResult;
});

// ↓ 下注按钮名称
const sBetBtnName = computed(()=>{
    if (!isAutoMode.value) { // 非自动模式只有一个按钮名称
        return $t('game.bet');
    }
    if (oForm.value.isSubmiting){
        return $t(oGlobalStore.autoModeBtnWords.stop);
    }
    return $t(oGlobalStore.autoModeBtnWords.start);
});

// ↓ 下注按钮禁用状态
const isBetBtnDisable = computed(()=>{
    if (!aPicked.length) { // 未选号，则禁用
        return true;
    }
    // ↓ 自动模式不禁用，因为可以中途取消下注
    // ↓ 甚至忽略 isLocking 的值，绝不禁用
    if (isAutoMode.value && oForm.value.isSubmiting) {
        return false; 
    }
    return !!isLocking.value;
});

// ↓ 操作面板禁用状态
const isPanelDisable = computed({
    get(){
        const bResult = (
            isLocking.value ||
            (isAutoMode.value && oForm.value.isSubmiting)
        );
        return bResult;
    },
    set(newVal){
        console.log("newVal", newVal);
    },
});

// --------- 👇其它 ------------------------------------

const toChangeMode = (isAuto)=>{
    isAutoMode.value = !!isAuto;
    if (isAuto){
        oAutoDialog.value.switchAutoDialogVisible(true);
    }
};

// ↓控制两侧的视频播放和停止
watch(oSetting, (newStatus)=>{
    if (!import.meta.client) return;
    let sAction = 'pause';
    if (newStatus.animation){
        sAction = 'play';
    }
    aSideVideo.value.forEach(cur=>{
        if (cur.dom) cur.dom[sAction]();
    });
}, {
    immediate: true,
    deep: true,
});

const oFn = {
    // ↓设定按钮样式（类名）
    getBtnClassName(iNumber){
        const hasChosen = aPicked.includes(iNumber);
        const keyName = hasChosen ? 'selected': 'default';
        const obj = {
            [keyName]: true,
        };
        if (isLocking.value){
            obj.locking = true;
        }
        if (aRollNumber.includes(iNumber)){
            obj.default = false;
            if (hasChosen){
                obj.win = true;
            }else{
                obj.result = true;
            }
        }
        return obj;
    },
    // ↓ 
    getBottomBarClassName(index){
        const aa = !!aRollNumber.length;
        const bb = index <= aNumbersHits.value.length;
        if (aa && bb){
            return {'coeficient-item__win': true};
        }
        return {};
    },
    // ↓点击一个数字
    clickNumber(curNo){
        aRollNumber.splice(0, 1/0);
        isGameDone.value = false;
        oMusic?.oAudio?.click?.toPlay();
        const idx = aPicked.indexOf(curNo);
        if (idx >= 0) {
            aPicked.splice(idx,1);
        }else{
            aPicked.push(curNo);
        }
    },
    // ↓ 清空选择
    cleanTable(){
        aPicked.splice(0, 1/0);
        aRollNumber.splice(0, 1/0);
        isLocking.value = false;
        isGameDone.value = false;
    },
    // ↓ 自动选择
    async autoPick(){
        oFn.cleanTable(); // 先清空
        isLocking.value = true;
        const obj = {};
        const {fast} = oSetting.value;
        for (let cur of Array(999).keys()){
            // console.log(cur, '=', iNumber) // ←通过打印记录来看，循环十几次即可得到10个不重复的值
            const iNumber = getRandomInt(1, 40);
            obj[iNumber] = true;
            if (Object.keys(obj).length >= 10){
                break;
            }
        }
        const aNumber = Object.keys(obj).map(cur => cur * 1);
        aNumber.sort((aa, bb) => aa - bb);
        for (let iNumber of aNumber){
            if (isUnmounted) break;
            if (!fast){
                await nextTick();
                await Sleep(120);
                if (isUnmounted) break;
                oMusic?.oAudio?.click?.toPlay();
            }
            aPicked.push(iNumber);
        }
        if (fast && !isUnmounted){ // 仅播放一次
            oMusic?.oAudio?.click?.toPlay();
        }
        isLocking.value = false;
    },
    // ↓切换风险程度
    handleSelectUpdate(newValue){
        console.log("新选择：\n", deepCopy(newValue));
        sRisk.value = newValue;
        const oTarget = aRiskOptionArr.value.find(option => {
            return option.value === newValue;
        });
        prevIcon.value = oTarget?.optionIcon;
    },
    // ↓点击下注按钮
    async clickBetBtn(){
        if (!aPicked.length) {
            return;
        }
        if (!betableCheck(oForm.value.amount)) return;
        Object.entries(oGameResult).forEach(oCur=>{
            const [key, val] = oCur;
            if (!val) return;
            const sFn = val.constructor.name;
            const newVal = new window[sFn]().valueOf();
            // console.log("val-newVal", val, ' | ', newVal);
            oGameResult[key] = newVal;
        });
        if (!isAutoMode.value){
            oForm.value.isSubmiting = false; // 手动模式，把自动模式的标记清除
            return oFn.placeBet();
        }
        // ↓以下处理自动模式
        if (oForm.value.isSubmiting){
            import.meta.dev && console.log('停止：自动下注---');
            stopInfinity();
        }else{
            import.meta.dev && console.log('开始：自动下注');
            startInfinity();
        }
    },
    // ↓执行下注（调用接口）
    async placeBet(){
        isLocking.value = true;
        isGameDone.value = false;
        aRollNumber.splice(0, 1/0);
        const obj = {
            "isFast": false,
            "risk": sRisk.value,
            "amount": oForm.value.amount,
            "selected": deepCopy(aPicked),
            "frontID": Date.now(),
        };
        console.log("aPicked", obj);
        const ts = oUserStore.queueStart(); // 防止余额立即变化
        oJoinStateStore.gameRunning = true;
        // if (import.meta.env.DEV_MODE && isAutoMode.value && Math.random() <= 0.2){ 
        //     obj.amount = 0; 
        // }
        const res = await EMIT_KENO_BET(obj) as any;
        if (import.meta.dev){
            console.log("下注后返回\n", deepCopy(res));
        }
        if (!res || res.error) {
            oUserStore.queueDelete(ts);
            isLocking.value = false;
            oJoinStateStore.gameRunning = false;
            if (!isAutoMode.value){
                showNegativeNotify(res?.[`error`]); 
            }
            return res;
        }
        Object.assign(oGameResult, res); // 先保存起来
        await oFn.showResult(res, ts);
        if (!oForm.value.isSubmiting){
            oJoinStateStore.gameRunning = false;
        }
        return {
            amount: res.amount,
            winAmount: res.winAmount,
        };
    },
    // ↓显示游戏结果
    async showResult(oResult, ts){
        const {selected, roll_number} = oResult;
        const {fast} = oSetting.value;
        aRollNumber.splice(0, 1/0);
        roll_number.sort((aa,bb) => aa-bb);
        for (const curNo of roll_number){
            if (isUnmounted) break;
            if (!fast){
                await nextTick();
                await Sleep(100);
                if (isUnmounted) break;
                const hasWon = selected.includes(curNo);
                const sMusic = hasWon ? 'ball' : 'result';
                oMusic?.oAudio?.[sMusic]?.toPlay();
            }
            aRollNumber.push(curNo);
        }
        await nextTick();
        await Sleep(100); // 调用 showDateInQueue() 之前等 0.1 秒，降低扑空概率 
        oJoinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
        oUserStore.queueForward(ts); // 显示余额变化
        isLocking.value = false; // 解锁
        const hasWon = oResult.winAmount > 0;
        const sMusic = hasWon ? 'win' : 'lose';
        oMusic?.oAudio?.[sMusic]?.toPlay();
        // ↓ 自动模式 || 没赢钱 then return 不显示结果 
        if (isAutoMode.value || !hasWon){
            if (isAutoMode.value) await Sleep(700); // 自动模式在此暂停，防止每局太快
            return;
        }
        // ↓ 自动模式执行 return，以下为手动模式专用 
        if (oForm.value.isSubmiting) return;
        setTimeout(() => {
            oJoinStateStore.gameRunning = false;
        }, 500);
        // ↓ 弹出游戏结果小窗口（自动模式不需要弹出） 
        isGameDone.value = true;
        await Sleep(1_200);
        isGameDone.value = false; // ←关闭游戏结果的窗口
    },
    // 是否触发预警动画
    async handleClickMask() {
        if (showWarning.value) return;
        if (!aPicked.length) {
            showWarning.value = true;
            await Sleep(800);
            showWarning.value = false;
        }
    },
};

// ↓设定默认下注金额 
useBettingToolkit(oForm.value);
const { stopInfinity, startInfinity, } = useAutoBetToolKit(
    oForm.value,
    oFn.placeBet,
);
onBeforeUnmount(()=>{
    isUnmounted = true;
    oMusic?.toDestory?.();
});

</script>
<style scoped src="./style/keno-left.scss" ></style>
<style scoped src="./style/keno.scss" ></style>



